import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendAPI } from '@core/models/backend-api';
import { Style } from '@core/models/style.model';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class StyleService {

	constructor(private http: HttpClient) { }

	public getStylesForPackageAndPlacement(packageId: string, placementId: string): Observable<Style[]> {
		const url = BackendAPI.staticDataStylesForPackageAndPlacement;
		const requestParams = new HttpParams()
			.set("packageId", packageId)
			.set("placementId", placementId);

		return this.http.get<Style[]>(url, { params: requestParams });
	}
}
